import { conversationPassengersTypes } from 'redux_new/conversations/types'
import apiUsers from 'api/users'

/**
 * Display container
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const display = (userId, isOpen, isLoading = false) => ({
  type: conversationPassengersTypes.display,
  isOpen,
  userId,
  isLoading,
})

/**
 * Update user passengers
 * @param {String} userId
 * @param {Object} [passengers=null]
 */
const update = (userId, passengers = []) => ({
  type: conversationPassengersTypes.update,
  userId,
  passengers,
})

/**
 * Close collapse for an user
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(display(activeUser, false))
}

/**
 * Get user's passengers
 */
const get = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(display(activeUser, true, true))

  try {
    const { data, status } = await apiUsers.passengers.get({ userId: activeUser })

    if (status === 200) {
      dispatch(update(activeUser, data.results || []))
    }
  } catch (error) {
    console.error('get Error status:', error.status, 'data:', error.data || error.message)
  }

  dispatch(update(activeUser))
}

/**
 * Add an user's passenger
 * @param {object} newPassenger
 */
const addOne = (newPassenger) => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  try {
    const { data, status } = await apiUsers.passengers.add({ userId: activeUser }, newPassenger)

    if (status !== 200) throw new Error({ status, data })

    dispatch(update(activeUser, data.results))

    return true
  } catch (error) {
    console.error('addOne Error status:', error.status, 'data:', error.data || error.message)

    throw new Error({ message: error.message || error.data })
  }
}

/**
 * Update an user's passenger
 * @param {object} newPassenger
 */
const updateOne = (newPassenger) => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  try {
    const { data, status } = await apiUsers.passengers.updateOne({ userId: activeUser }, newPassenger)

    if (status !== 200) throw new Error({ status, data })

    dispatch(update(activeUser, data.results))

    return true
  } catch (error) {
    console.error('updateOne Error status:', error.status, 'data:', error.data || error.message)

    throw new Error({ message: error.message || error.data })
  }
}

/**
 * Delete an user's passenger
 * @param {string} passengerId
 */
const deleteOne = (passengerId) => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  try {
    const { data, status } = await apiUsers.passengers.deleteOne({
      userId: activeUser,
      passengerId,
    })

    if (status !== 200) throw new Error({ status, data })

    dispatch(update(activeUser, data.results))

    return true
  } catch (error) {
    console.error('deleteOne Error status:', error.status, 'data:', error.data || error.message)

    throw new Error({ message: error.message || error.data })
  }
}

export default {
  close,
  get,
  addOne,
  updateOne,
  deleteOne,
}
